export function logOut(response) {
    if (!response.ERROR_STATUS) {
        // Redirect to the homepage
        alert('Token expired. Please logout & login again.')
        window.location.href = '/';  // Correct syntax for redirecting
    }
}